<template>
  <div>
    <h1 class="mb-4 text-2xl font-bold">Detail Profil Jurusan</h1>
    <div class="mb-4">
      <strong>Visi:</strong>
      <div>{{ profil_jurusan.visi }}</div>
    </div>
    <div class="mb-4">
      <strong>Misi:</strong>
      <div>{{ profil_jurusan.misi }}</div>
    </div>
    <div class="mb-4">
      <strong>Akreditasi:</strong>
      <div>{{ profil_jurusan.akreditasi }}</div>
    </div>
    <Link :href="route('profil-jurusan.index')" class="btn">Kembali</Link>
  </div>
</template>

<script setup>
import { inject } from "vue";
import { Link } from "@inertiajs/vue3";
const route = inject('route');
const props = defineProps({ profil_jurusan: Object });
</script>
